<template>
  <div class="wrapper limit">
    <div class="image-wrap">
      <div class="image" :style="`background-image: url(${img})`"></div>
      <div class="overlay" :class="{'inverse' : inverse}" v-if="img != null"></div>
    </div>
    <div class="full-image" :class="{'inverse' : inverse}" >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  props: {
    inverse: Boolean,
    img: String
  },
  components: {}
};
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  position: relative;

  .image-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;

    z-index: -1;

    .image {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      position: absolute;
      top: 0;
      left: 0;

      z-index: -1;
    }

    .overlay {
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.25);

      &.inverse {
        background-color: rgba(0, 0, 0, 0.25);
      }
    }
  }
}

.full-image {
  // @include cover-center;

  width: 100%;
  height: 600px;

  // @media screen and (max-width: 950px) {
  //   height: 450px;
  // }

  &.inverse p {
    color: white;
  }

  display: flex;
  justify-content: center;
  align-items: center;

  p {
       color: black;
    font-size: 40px;

    @media screen and (max-width: 950px) {
    font-size: 20px;
    line-height: 40px;
  }
 
    max-width: 75%;
    line-height: 80px;
    text-transform: uppercase;
  }
}
</style>
